import {computed} from "vue";
import {useUserStore} from "@/stores/user";

export const useAuthorizedUsers = () => {
  const userStore = useUserStore()
  const isAuthorized = computed(() => {
    const authorizedUsers = JSON.parse(process.env.VUE_APP_SHOW_EDIT)
    return !!authorizedUsers.includes(userStore.user?.userId);

  })

  return {
    isAuthorized
  }
}